export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/android_app.df5bae9.svg";